"use strict";
/*
 * Created on 10 14 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * @author Jaroslav Sevcik
 */


var SimpleExportedEntityConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SimpleExportedEntityConverter, _DataObjectConverter_);

  function SimpleExportedEntityConverter() {
    _classCallCheck(this, SimpleExportedEntityConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SimpleExportedEntityConverter).apply(this, arguments));
  }

  return SimpleExportedEntityConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SimpleExportedEntityConverter = SimpleExportedEntityConverter;